export const ingredients = [
    { id: 1, name: "Fils de coton", quantity: 500, unit: "mètres" },
    { id: 2, name: "Élastiques", quantity: 200, unit: "pièces" },
    { id: 3, name: "Boutons", quantity: 300, unit: "pièces" },
];
